// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  onNativeInsetsChange?: DirectEventHandler<Readonly<{
    insetTop: Double;
    insetRight: Double;
    insetBottom: Double;
    insetLeft: Double;
    frameX: Double;
    frameY: Double;
    frameWidth: Double;
    frameHeight: Double;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeSafeAreaProvider';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeSafeAreaProvider",
  directEventTypes: {
    topNativeInsetsChange: {
      registrationName: "onNativeInsetsChange"
    }
  },
  validAttributes: {
    ...ConditionallyIgnoredEventHandlers({
      onNativeInsetsChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);